/**
 * Reading a Hebrew year off a start date, for labeling.
 *
 * How an occasion FALLS is not derived here — `occasion.fallPatterns` owns that,
 * because a pattern is (weekday, the conditions holding on day one) and the
 * conditions are the calendar's to compute. A second derivation on the client
 * could only ever be the weekday half, which is the wrong answer for any chag
 * that can fall the same weekday two different ways.
 */

/**
 * Hebrew year for a start date. A civil year maps to +3760 before Rosh Hashana
 * and +3761 from Rosh Hashana on (~September) — approximated by the month, which
 * is exact for a chag's day 1 (they never start in the early-September fuzz).
 */
export const hebrewYearOf = (isoDate: string) => {
  const d = new Date(`${isoDate}T12:00:00`)
  return d.getFullYear() + 3760 + (d.getMonth() >= 8 ? 1 : 0)
}
/** Civil-year span of a Hebrew year, e.g. 5786 → "2025–26". */
export const civilSpanOf = (hebrewYear: number) =>
  `${hebrewYear - 3761}–${String((hebrewYear - 3760) % 100).padStart(2, '0')}`
